import React from "react";
import { MenuSelect } from "./Form";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { FiEdit, FiEye } from "react-icons/fi";
import { RiDeleteBin6Line, RiDeleteBinLine } from "react-icons/ri";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const thclass = "text-start text-sm font-medium py-3 px-2 whitespace-nowrap";
const tdclass = "text-start text-sm py-4 px-2 whitespace-nowrap";

export function Transactiontable({ data, action, functions }) {
  const DropDown1 = [
    {
      title: "Edit",
      icon: FiEdit,
      onClick: (data) => {
        functions.edit(data.id);
      },
    },
    {
      title: "View",
      icon: FiEye,
      onClick: (data) => {
        functions.preview(data.id);
      },
    },
    {
      title: "Delete",
      icon: RiDeleteBin6Line,
      onClick: () => {
        toast.error("This feature is not available yet");
      },
    },
  ];
  return (
    <table className='w-full table-auto'>
      <thead className='overflow-hidden rounded-md bg-dry'>
        <tr>
          <th className={thclass}>#</th>
          <th className={thclass}>Patient</th>
          <th className={thclass}>Date</th>
          <th className={thclass}>Status</th>
          <th className={thclass}>
            Amout <span className='text-xs font-light'>(Tsh)</span>
          </th>
          <th className={thclass}>Method</th>
          {action && <th className={thclass}>Actions</th>}
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr
            key={item.id}
            className='transitions border-b border-border hover:bg-greyed'
          >
            <td className={tdclass}>{index + 1}</td>
            <td className={tdclass}>
              <div className='flex items-center gap-4'>
                <span className='w-12'>
                  <img
                    src={item.user.image}
                    alt={item.user.title}
                    className='h-12 w-full rounded-full border border-border object-cover'
                  />
                </span>

                <div>
                  <h4 className='text-sm font-medium'>{item.user.title}</h4>
                  <p className='mt-1 text-xs text-textGray'>
                    {item.user.phone}
                  </p>
                </div>
              </div>
            </td>
            <td className={tdclass}>{item.date}</td>
            <td className={tdclass}>
              <span
                className={`px-4 py-1 ${
                  item.status === "Paid"
                    ? "bg-subMain text-subMain"
                    : item.status === "Pending"
                      ? "bg-orange-500 text-orange-500"
                      : item.status === "Cancel" && "bg-red-600 text-red-600"
                } rounded-xl bg-opacity-10 text-xs`}
              >
                {item.status}
              </span>
            </td>
            <td className={`${tdclass} font-semibold`}>{item.amount}</td>
            <td className={tdclass}>{item.method}</td>
            {action && (
              <td className={tdclass}>
                <MenuSelect datas={DropDown1} item={item}>
                  <div className='rounded-lg border bg-dry px-4 py-2 text-xl text-main'>
                    <BiDotsHorizontalRounded />
                  </div>
                </MenuSelect>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// invoice table
export function InvoiceTable({ data }) {
  const navigate = useNavigate();
  const DropDown1 = [
    {
      title: "Edit",
      icon: FiEdit,
      onClick: (item) => {
        navigate(`/invoices/edit/${item.id}`);
      },
    },
    {
      title: "View",
      icon: FiEye,
      onClick: (item) => {
        navigate(`/invoices/preview/${item.id}`);
      },
    },
    {
      title: "Delete",
      icon: RiDeleteBin6Line,
      onClick: () => {
        toast.error("This feature is not available yet");
      },
    },
  ];
  return (
    <table className='w-full table-auto'>
      <thead className='overflow-hidden rounded-md bg-dry'>
        <tr>
          <th className={thclass}>Invoice ID</th>
          <th className={thclass}>Patient</th>
          <th className={thclass}>Created Date</th>
          <th className={thclass}>Due Date</th>
          <th className={thclass}>
            Amout <span className='text-xs font-light'>(Tsh)</span>
          </th>
          <th className={thclass}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <tr
            key={item.id}
            className='transitions border-b border-border hover:bg-greyed'
          >
            <td className={tdclass}>#{item?.id}</td>
            <td className={tdclass}>
              <div className='flex items-center gap-4'>
                <span className='w-12'>
                  <img
                    src={item?.to?.image}
                    alt={item?.to?.title}
                    className='h-12 w-full rounded-full border border-border object-cover'
                  />
                </span>
                <div>
                  <h4 className='text-sm font-medium'>{item?.to?.title}</h4>
                  <p className='mt-1 text-xs text-textGray'>
                    {item?.to?.email}
                  </p>
                </div>
              </div>
            </td>
            <td className={tdclass}>{item?.createdDate}</td>
            <td className={tdclass}>{item?.dueDate}</td>
            <td className={`${tdclass} font-semibold`}>{item?.total}</td>
            <td className={tdclass}>
              <MenuSelect datas={DropDown1} item={item}>
                <div className='rounded-lg border bg-dry px-4 py-2 text-xl text-main'>
                  <BiDotsHorizontalRounded />
                </div>
              </MenuSelect>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// prescription table
export function MedicineTable({ data, onEdit, onDelete }) {
  const [deleteConfirm, setDeleteConfirm] = React.useState(null);

  const DropDown1 = [
    {
      title: "Edit",
      icon: FiEdit,
      onClick: (item) => {
        onEdit(item);
      },
    },
    {
      title: "Delete",
      icon: RiDeleteBin6Line,
      onClick: (item) => {
        setDeleteConfirm(item);
      },
    },
  ];

  const handleDeleteConfirm = async () => {
    if (!deleteConfirm) return;
    if (onDelete) {
      onDelete(deleteConfirm);
    } else {
      toast.error("Delete function not available");
    }
    setDeleteConfirm(null);
  };

  return (
    <>
      {/* Delete Confirmation Modal */}
      {deleteConfirm && (
        <div className='fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-50'>
          <div className='mx-4 w-full max-w-md rounded-lg bg-white p-6 shadow-xl'>
            <h3 className='mb-4 text-lg font-semibold'>Confirm Delete</h3>
            <p className='mb-6 text-sm text-textGray'>
              Are you sure you want to delete{" "}
              <span className='font-semibold text-main'>
                {deleteConfirm?.name}
              </span>
              ? This action cannot be undone.
            </p>
            <div className='flex justify-end gap-4'>
              <button
                onClick={() => setDeleteConfirm(null)}
                className='rounded-lg bg-[#B8B8B8] px-4 py-2 text-sm font-light text-white hover:opacity-80'
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteConfirm}
                className='rounded-lg bg-red-600 px-4 py-2 text-sm font-light text-white hover:opacity-80'
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <table className='w-full table-auto'>
        <thead className='overflow-hidden rounded-md bg-dry'>
          <tr>
            <th className={thclass}>Name</th>
            <th className={thclass}>
              Price <span className='text-xs font-light'>(Tsh)</span>
            </th>
            <th className={thclass}>Status</th>
            <th className={thclass}>InStock</th>
            <th className={thclass}>Measure</th>
            <th className={thclass}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr
              key={item.id}
              className='transitions border-b border-border hover:bg-greyed'
            >
              <td className={tdclass}>
                <h4 className='text-sm font-medium'>{item?.name}</h4>
              </td>
              <td className={`${tdclass} font-semibold`}>{item?.price}</td>
              <td className={tdclass}>
                <span
                  className={`text-xs font-medium ${
                    item?.status === "Out of stock"
                      ? "text-red-600"
                      : "text-green-600"
                  }`}
                >
                  {item?.status}
                </span>
              </td>
              <td className={tdclass}>{item?.stock}</td>
              <td className={tdclass}>{item?.measure}</td>
              <td className={tdclass}>
                <MenuSelect datas={DropDown1} item={item}>
                  <div className='rounded-lg border bg-dry px-4 py-2 text-xl text-main'>
                    <BiDotsHorizontalRounded />
                  </div>
                </MenuSelect>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

// service table
export function ServiceTable({ data, onEdit, onDelete }) {
  const [deleteConfirm, setDeleteConfirm] = React.useState(null);

  const DropDown1 = [
    {
      title: "Edit",
      icon: FiEdit,
      onClick: (item) => {
        onEdit(item);
      },
    },
    {
      title: "Delete",
      icon: RiDeleteBin6Line,
      onClick: (item) => {
        setDeleteConfirm(item);
      },
    },
  ];

  const handleDeleteConfirm = async () => {
    if (!deleteConfirm) return;
    if (onDelete) {
      onDelete(deleteConfirm);
    } else {
      toast.error("Delete function not available");
    }
    setDeleteConfirm(null);
  };

  return (
    <>
      {/* Delete Confirmation Modal */}
      {deleteConfirm && (
        <div className='fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-50'>
          <div className='mx-4 w-full max-w-md rounded-lg bg-white p-6 shadow-xl'>
            <h3 className='mb-4 text-lg font-semibold'>Confirm Delete</h3>
            <p className='mb-6 text-sm text-textGray'>
              Are you sure you want to delete{" "}
              <span className='font-semibold text-main'>
                {deleteConfirm?.name}
              </span>
              ? This action cannot be undone.
            </p>
            <div className='flex justify-end gap-4'>
              <button
                onClick={() => setDeleteConfirm(null)}
                className='rounded-lg bg-[#B8B8B8] px-4 py-2 text-sm font-light text-white hover:opacity-80'
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteConfirm}
                className='rounded-lg bg-red-600 px-4 py-2 text-sm font-light text-white hover:opacity-80'
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <table className='w-full table-auto'>
        <thead className='overflow-hidden rounded-md bg-dry'>
          <tr>
            <th className={thclass}>Name</th>
            <th className={thclass}>Created At</th>
            <th className={thclass}>
              Price <span className='text-xs font-light'>(Tsh)</span>
            </th>
            <th className={thclass}>Status</th>
            <th className={thclass}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr
              key={item.id}
              className='transitions border-b border-border hover:bg-greyed'
            >
              <td className={tdclass}>
                <h4 className='text-sm font-medium'>{item?.name}</h4>
              </td>
              <td className={tdclass}>{item?.date}</td>
              <td className={`${tdclass} font-semibold`}>{item?.price}</td>
              <td className={tdclass}>
                <span
                  className={`text-xs font-medium ${
                    !item?.status ? "text-red-600" : "text-green-600"
                  }`}
                >
                  {!item?.status ? "Disabled" : "Enabled"}
                </span>
              </td>
              <td className={tdclass}>
                <MenuSelect datas={DropDown1} item={item}>
                  <div className='rounded-lg border bg-dry px-4 py-2 text-xl text-main'>
                    <BiDotsHorizontalRounded />
                  </div>
                </MenuSelect>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

// Helper function to get initials from name (first two letters)
const getInitials = (name) => {
  if (!name) return "??";
  const words = name.trim().split(/\s+/);
  if (words.length >= 2) {
    // First letter of first word + first letter of second word
    return (words[0][0] + words[1][0]).toUpperCase();
  } else if (words.length === 1) {
    // If only one word, take first two letters
    return words[0].substring(0, 2).toUpperCase();
  }
  return "??";
};

// Helper function to get consistent avatar color based on name
const getAvatarColor = (name) => {
  const colors = [
    "#E5E7EB", // light gray
    "#FEE2E2", // light red/pink
    "#D1FAE5", // light green
    "#FEF3C7", // light yellow
    "#DBEAFE", // light blue
    "#E9D5FF", // light purple
    "#FCE7F3", // light pink
    "#D1D5DB", // gray
  ];

  if (!name) return colors[0];

  // Use name to generate consistent color
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  return colors[Math.abs(hash) % colors.length];
};

// patient table
export function PatientTable({ data, functions, used }) {
  const DropDown1 = !used
    ? [
        {
          title: "View",
          icon: FiEye,
          onClick: (data) => {
            functions.preview(data.id);
          },
        },
        {
          title: "Delete",
          icon: RiDeleteBin6Line,
          onClick: () => {
            toast.error("This feature is not available yet");
          },
        },
      ]
    : [
        {
          title: "View",
          icon: FiEye,
          onClick: (data) => {
            functions.preview(data.id);
          },
        },
      ];
  const thclasse = "text-start text-sm font-medium py-3 px-2 whitespace-nowrap";
  const tdclasse = "text-start text-xs py-4 px-2 whitespace-nowrap";
  return (
    <table className='w-full table-auto'>
      <thead className='overflow-hidden rounded-md bg-dry'>
        <tr>
          <th className={thclasse}>#</th>
          <th className={thclasse}>Patient</th>
          <th className={thclasse}>Created At</th>
          <th className={thclasse}>Gender</th>
          {!used && (
            <>
              <th className={thclasse}>Blood Group</th>
              <th className={thclasse}>Age</th>
            </>
          )}

          <th className={thclasse}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr
            key={item.id}
            className='transitions border-b border-border hover:bg-greyed'
          >
            <td className={tdclasse}>{index + 1}</td>
            <td className={tdclasse}>
              <div className='flex items-center gap-4'>
                {!used && (
                  <div
                    className='flex h-12 w-12 items-center justify-center rounded-full border border-border text-sm font-medium text-main'
                    style={{
                      backgroundColor: getAvatarColor(item.title || ""),
                    }}
                  >
                    {getInitials(item.title || item.user?.title || "Unknown")}
                  </div>
                )}

                <div>
                  <h4 className='text-sm font-medium'>
                    {item.title || item.user?.title || "Unknown"}
                  </h4>
                </div>
              </div>
            </td>
            <td className={tdclasse}>{item.date}</td>

            <td className={tdclasse}>
              <span
                className={`px-4 py-1 ${
                  item.gender === "Male"
                    ? "bg-[#0095D9] text-[#0095D9]"
                    : "bg-red-500 text-red-500"
                } rounded-xl bg-opacity-10 text-xs`}
              >
                {item.gender}
              </span>
            </td>
            {!used && (
              <>
                <td className={tdclasse}>{item.blood}</td>
                <td className={tdclasse}>{item.age}</td>
              </>
            )}

            <td className={tdclasse}>
              <MenuSelect datas={DropDown1} item={item}>
                <div className='rounded-full border bg-dry p-2 text-xl text-main'>
                  <BiDotsHorizontalRounded />
                </div>
              </MenuSelect>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// Facility table
export function FacilityTable({ data, functions, doctor }) {
  const DropDown1 = [
    {
      title: "View",
      icon: FiEye,
      onClick: (data) => {
        functions.preview(data);
      },
    },
    {
      title: "Delete",
      icon: RiDeleteBin6Line,
      onClick: () => {
        toast.error("This feature is not available yet");
      },
    },
  ];
  return (
    <table className='w-full table-auto'>
      <thead className='overflow-hidden rounded-md bg-dry'>
        <tr>
          <th className={thclass}>#</th>
          <th className={thclass}>Name</th>
          <th className={thclass}>Integration type & Invitation for:</th>
          <th className={thclass}>Facility type</th>
          <th className={thclass}>HFR/Email ID</th>
          <th className={thclass}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr
            key={item.id}
            className='transitions border-b border-border hover:bg-greyed'
          >
            <td className={tdclass}>{index + 1}</td>
            <td className={tdclass}>
              <div className='flex items-center gap-4'>
                <span className='w-12'>
                  <img
                    src={item.image}
                    alt={item.name}
                    className='h-12 w-full rounded-full border border-border object-cover'
                  />
                </span>
                <h4 className='text-sm font-medium'>{item.name}</h4>
              </div>
            </td>
            <td className={tdclass}>{item.invitationFor}</td>
            <td className={tdclass}>
              <p className='text-textGray'>{item.type}</p>
            </td>
            <td className={tdclass}>{item.email}</td>

            <td className={tdclass}>
              <MenuSelect datas={DropDown1} item={item}>
                <div className='rounded-lg border bg-dry px-4 py-2 text-xl text-main'>
                  <BiDotsHorizontalRounded />
                </div>
              </MenuSelect>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// doctor table
// Helper function to format date
const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "N/A";

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  } catch (error) {
    return "N/A";
  }
};

export function DoctorsTable({ data, functions, doctor }) {
  const [deleteConfirm, setDeleteConfirm] = React.useState(null);

  const DropDown1 = [
    {
      title: "View",
      icon: FiEye,
      onClick: (data) => {
        functions.preview(data);
      },
    },
    {
      title: "Delete",
      icon: RiDeleteBin6Line,
      onClick: (data) => {
        setDeleteConfirm(data);
      },
    },
  ];

  const handleDeleteConfirm = async () => {
    if (!deleteConfirm) return;

    try {
      if (functions.delete) {
        await functions.delete(deleteConfirm);
        // Don't show toast here - let handleDelete function handle it
      } else {
        toast.error("Delete function not available");
      }
      setDeleteConfirm(null);
    } catch (error) {
      // Error toast is already handled in handleDelete function
      setDeleteConfirm(null);
    }
  };

  return (
    <>
      {/* Delete Confirmation Modal */}
      {deleteConfirm && (
        <div className='fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-50'>
          <div className='mx-4 w-full max-w-md rounded-lg bg-white p-6 shadow-xl'>
            <h3 className='mb-4 text-lg font-semibold'>Confirm Delete</h3>
            <p className='mb-6 text-sm text-textGray'>
              Are you sure you want to delete{" "}
              <span className='font-semibold text-main'>
                {deleteConfirm.user?.title || "this staff member"}
              </span>
              ? This action cannot be undone.
            </p>
            <div className='flex justify-end gap-4'>
              <button
                onClick={() => setDeleteConfirm(null)}
                className='rounded-lg bg-[#B8B8B8] px-4 py-2 text-sm font-light text-white hover:opacity-80'
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteConfirm}
                className='rounded-lg bg-red-600 px-4 py-2 text-sm font-light text-white hover:opacity-80'
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      <table className='w-full table-auto'>
        <thead className='overflow-hidden rounded-md bg-dry'>
          <tr>
            <th className={thclass}>#</th>
            <th className={thclass}>
              {doctor ? "Doctor & Nurse" : "Receptionist"}
            </th>
            <th className={thclass}>Joined At</th>
            <th className={thclass}>Phone</th>
            <th className={thclass}>Access</th>
            <th className={thclass}>Email ID</th>
            <th className={thclass}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr
              key={item.id}
              className='transitions border-b border-border hover:bg-greyed'
            >
              <td className={tdclass}>{index + 1}</td>
              <td className={tdclass}>
                <div className='flex items-center gap-4'>
                  <span className='w-12'>
                    <img
                      src={item.user.image}
                      alt={item.user.title}
                      className='h-12 w-full rounded-full border border-border object-cover'
                    />
                  </span>
                  <h4 className='text-sm font-medium'>{item.user.title}</h4>
                </div>
              </td>
              <td className={tdclass}>
                {formatDate(item.createdAt || item.joinedAt)}
              </td>
              <td className={tdclass}>
                <p className='text-textGray'>{item.user.phone}</p>
              </td>
              <td className={tdclass}>
                <span
                  className={`rounded-xl bg-opacity-10 px-4 py-1 text-xs ${
                    item.role === "2"
                      ? "bg-orange-500 text-orange-500"
                      : item.role === "3"
                        ? "bg-subMain text-subMain"
                        : "bg-gray-500 text-gray-500"
                  }`}
                >
                  {item.role === "2"
                    ? "Admin"
                    : item.role === "3"
                      ? "Manager"
                      : "Member"}
                </span>
              </td>
              <td className={tdclass}>{item.user.email}</td>

              <td className={`${tdclass} relative`}>
                <div className='relative'>
                  <MenuSelect datas={DropDown1} item={item}>
                    <div className='cursor-pointer rounded-lg border bg-dry px-4 py-2 text-xl text-main'>
                      <BiDotsHorizontalRounded />
                    </div>
                  </MenuSelect>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

// appointment table
export function AppointmentTable({ data, functions, doctor }) {
  return (
    <table className='w-full table-auto'>
      <thead className='overflow-hidden rounded-md bg-dry'>
        <tr>
          <th className={thclass}>Date</th>
          <th className={thclass}>{doctor ? "Patient" : "Doctor"}</th>
          <th className={thclass}>Status</th>
          <th className={thclass}>Time</th>
          <th className={thclass}>Action</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <tr
            key={item.id}
            className='transitions border-b border-border hover:bg-greyed'
          >
            <td className={tdclass}>
              <p className='text-xs'>{item.date}</p>
            </td>
            <td className={tdclass}>
              <h4 className='text-xs font-medium'>
                {doctor ? item.user.title : item.doctor.title}
              </h4>
              <p className='mt-1 text-xs text-textGray'>
                {doctor ? item.user.phone : item.doctor.phone}
              </p>
            </td>
            <td className={tdclass}>
              <span
                className={`px-4 py-1 ${
                  item.status === "Approved"
                    ? "bg-subMain text-subMain"
                    : item.status === "Pending"
                      ? "bg-orange-500 text-orange-500"
                      : item.status === "Cancel" && "bg-red-600 text-red-600"
                } rounded-xl bg-opacity-10 text-xs`}
              >
                {item.status}
              </span>
            </td>
            <td className={tdclass}>
              <p className='text-xs'>{`${item.from} - ${item.to}`}</p>
            </td>

            <td className={tdclass}>
              <button
                onClick={() => functions.preview(item)}
                className='flex-colo h-10 w-10 rounded-md border bg-white text-sm text-subMain'
              >
                <FiEye />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// payment table
export function PaymentTable({ data, functions, doctor }) {
  return (
    <table className='w-full table-auto'>
      <thead className='overflow-hidden rounded-md bg-dry'>
        <tr>
          <th className={thclass}>Date</th>
          <th className={thclass}>{doctor ? "Patient" : "Doctor"}</th>
          <th className={thclass}>Status</th>
          <th className={thclass}>Amount</th>
          <th className={thclass}>Method</th>
          <th className={thclass}>Action</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <tr
            key={item.id}
            className='transitions border-b border-border hover:bg-greyed'
          >
            <td className={tdclass}>
              <p className='text-xs'>{item.date}</p>
            </td>
            <td className={tdclass}>
              <h4 className='text-xs font-medium'>
                {doctor ? item.user.title : item.doctor.title}
              </h4>
              <p className='mt-1 text-xs text-textGray'>
                {doctor ? item.user.phone : item.doctor.phone}
              </p>
            </td>
            <td className={tdclass}>
              <span
                className={`px-4 py-1 ${
                  item.status === "Paid"
                    ? "bg-subMain text-subMain"
                    : item.status === "Pending"
                      ? "bg-orange-500 text-orange-500"
                      : item.status === "Cancel" && "bg-red-600 text-red-600"
                } rounded-xl bg-opacity-10 text-xs`}
              >
                {item.status}
              </span>
            </td>
            <td className={tdclass}>
              <p className='text-xs font-semibold'>{`$${item.amount}`}</p>
            </td>
            <td className={tdclass}>
              <p className='text-xs'>{item.method}</p>
            </td>

            <td className={tdclass}>
              <button
                onClick={() => functions.preview(item.id)}
                className='flex-colo h-10 w-10 rounded-md border bg-white text-sm text-subMain'
              >
                <FiEye />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// invoice used table
export function InvoiceUsedTable({ data, functions }) {
  return (
    <table className='w-full table-auto'>
      <thead className='overflow-hidden rounded-md bg-dry'>
        <tr>
          <th className={thclass}>Invoice ID</th>
          <th className={thclass}>Create Date</th>
          <th className={thclass}>Due Date</th>
          <th className={thclass}>Amount</th>
          <th className={thclass}>Action</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <tr
            key={item.id}
            className='transitions border-b border-border hover:bg-greyed'
          >
            <td className={tdclass}>
              <p className='text-xs'>#{item.id}</p>
            </td>
            <td className={tdclass}>
              <p className='text-xs'>{item.createdDate}</p>
            </td>
            <td className={tdclass}>
              <p className='text-xs'>{item.dueDate}</p>
            </td>

            <td className={tdclass}>
              <p className='text-xs font-semibold'>{`$${item.total}`}</p>
            </td>

            <td className={tdclass}>
              <button
                onClick={() => functions.preview(item.id)}
                className='flex-colo h-10 w-10 rounded-md border bg-white text-sm text-subMain'
              >
                <FiEye />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// invoice table
export function InvoiceProductsTable({ data, functions, button }) {
  return (
    <table className='w-full table-auto'>
      <thead className='overflow-hidden rounded-md bg-dry'>
        <tr>
          <th className={thclass}>Item</th>
          <th className={thclass}>
            Item Price
            <span className='ml-1 text-xs font-light'>(Tsh)</span>
          </th>
          <th className={thclass}>Quantity</th>
          <th className={thclass}>
            Amout
            <span className='ml-1 text-xs font-light'>(Tsh)</span>
          </th>
          {button && <th className={thclass}>Actions</th>}
        </tr>
      </thead>
      <tbody>
        {data?.map((item) => (
          <tr
            key={item.id}
            className='transitions border-b border-border hover:bg-greyed'
          >
            <td className={`${tdclass} font-medium`}>{item.name}</td>
            <td className={`${tdclass} text-xs`}>{item.price}</td>
            <td className={tdclass}>{item.id}</td>
            <td className={tdclass}>{item.price * item.id}</td>
            {button && (
              <td className={tdclass}>
                <button
                  onClick={() => functions.deleteItem(item.id)}
                  className='rounded-lg border border-red-100 bg-red-600 bg-opacity-5 px-4 py-3 text-sm text-red-600'
                >
                  <RiDeleteBinLine />
                </button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// medicine Dosage table

export function MedicineDosageTable({ data, functions, button }) {
  const thclasse = "text-start text-xs font-medium py-3 px-2 whitespace-nowrap";
  const tdclasse = "text-start text-xs py-4 px-2 whitespace-nowrap";
  return (
    <table className='w-full table-auto'>
      <thead className='overflow-hidden rounded-md bg-dry'>
        <tr>
          <th className={thclasse}>Item</th>
          <th className={thclasse}>
            Item Price
            <span className='ml-1 text-xs font-light'>(Tsh)</span>
          </th>
          <th className={thclasse}>Dosage</th>
          <th className={thclasse}>Instraction</th>
          <th className={thclasse}>Quantity</th>
          <th className={thclasse}>
            Amount
            <span className='ml-1 text-xs font-light'>(Tsh)</span>
          </th>
          {button && <th className={thclasse}>Actions</th>}
        </tr>
      </thead>
      <tbody>
        {data?.map((item) => (
          <tr
            key={item.id}
            className='transitions border-b border-border hover:bg-greyed'
          >
            <td className={tdclasse}>{item.name}</td>
            <td className={tdclasse}>{item.price}</td>
            <td className={tdclasse}>{item.id} - M/A/E</td>
            <td className={tdclasse}>{item.instraction}</td>
            <td className={tdclasse}>{item.id}</td>
            <td className={tdclasse}>{item.price * item.id}</td>
            {button && (
              <td className={tdclasse}>
                <button
                  onClick={() => functions.delete(item.id)}
                  className='rounded-lg border border-red-100 bg-red-600 bg-opacity-5 px-4 py-3 text-sm text-red-600'
                >
                  <RiDeleteBinLine />
                </button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
